import React from "react";
import styles from "./../../sass/landing/numbers.module.scss";
import classNames from "classnames";
import step1 from './../assets/icons/step1.svg';
import step2 from './../assets/icons/step2.svg';
import step3 from './../assets/icons/step3.svg';
import step4 from './../assets/icons/step4.svg';
import arrow from './../assets/icons/arrow-right.png';
import arrowAlt from './../assets/icons/arrow-right-alt.png';

const Numbers = (props) => {
  return (
    <>
      <div className={classNames(styles["numbers"], "container")}>
        <div className="row justify-content-center">
          <div className="col-md-10 col-12 text-center">
            <h3>
              What is a Carbon Credit?
            </h3>
            <p>1 Carbon Credit = a digital certificate proving a company or an environmental project prevented the emission (pollution) of 1 ton of CO2eq (carbon dioxide)</p>
          </div>
        </div>
      </div>
      <div className={classNames(styles["tiles"], "container")}>
        <div className="row flex-nowrap flex-lg-wrap h-100">
          <div className="col-xl-3 col-lg-3 col-md-5 col-8 mb-3">
            <div className={classNames(styles["tile"])}>
              <img src={step1} alt="Icon"/>
              <p>Environmental projects earn carbon credits</p>
              <img src={arrow} alt="arrow right" className={classNames(styles["arrow"])}/>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-5 col-8 mb-3">
            <div className={classNames(styles["tile"])}>
              <img src={step2} alt="Icon"/>
              <p>They are submitted to the BCX</p>
              <img src={arrowAlt} alt="arrow right" className={classNames(styles["arrow"],styles["arrow-alt"])}/>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-5 col-8 mb-3">
            <div className={classNames(styles["tile"])}>
              <img src={step3} alt="Icon"/>
              <p>Our team audits them for compliance and quality</p>
              <img src={arrow} alt="arrow right" className={classNames(styles["arrow"])}/>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-5 col-8 mb-3">
            <div className={classNames(styles["tile"])}>
              <img src={step4} alt="Icon"/>
              <p>Approved credits are listed on the exchange and available for trading.</p>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Numbers;
